import '@hotmart/cosmos/dist/form/input-validate.css'
import '@hotmart/cosmos/dist/styles/utilities/text/text.css'
import '@hotmart/cosmos/dist/styles/utilities/spacing/spacing.css'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/text/variations/grays.css'

export type FeedbackMessageProps = {
  error?: string
  hint?: string
}

const FeedbackMessage = ({ error, hint }: FeedbackMessageProps) => {
  if (error) {
    return <p className='_mb-0 invalid-feedback _d-block'>{error}</p>
  }

  return hint ? <p className='_text-1 _text-gray-500 _mt-1 _mb-0'>{hint}</p> : null
}

export default FeedbackMessage
